window.globalHelpersModule = angular.module('GlobalHelpersModule', [])

const context = require.context(".", true, /\.coffee$/);
context.keys().forEach(function (key) {
    context(key);
});